// extracted by mini-css-extract-plugin
export default {"dataTable":"MergePreviewTableCard_dataTable__MPUiV","card":"MergePreviewTableCard_card__iWFnr","footer":"MergePreviewTableCard_footer__HpQUf"};